import { render, staticRenderFns } from "./gridNewIndex.vue?vue&type=template&id=5aae536e&scoped=true&"
import script from "./gridNewIndex.vue?vue&type=script&lang=js&"
export * from "./gridNewIndex.vue?vue&type=script&lang=js&"
import style0 from "./gridNewIndex.vue?vue&type=style&index=0&id=5aae536e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aae536e",
  null
  
)

export default component.exports